exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.graph-container[data-v-60732251] {\n  height: 300px;\n}\n", ""]);

// exports
